
import { useParams } from 'react-router-dom';
import { RolesFormState } from '../../../context/roles/RolesFormState';
import { Form } from './form';

export const RolesFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Rol" : "Crear Rol";

  return (
    <RolesFormState>
        <br />
        <Form title={title} />
    </RolesFormState>
  );
};
